import React, { Component } from "react";
import { Link } from "react-router-dom";
// styles for page
import "./projects.css";
// icons for page
import Ionicon from "react-ionicons";

// test
import Test from "../../../assets/images/logo.svg";

export default class UnPublished extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  // get bloob url from file
  getUrlFromObj = e => {
    let imagePreview;
    let binaryData = [];
    if (e) {
      binaryData.push(e);
      imagePreview = window.URL.createObjectURL(new Blob(binaryData));
      return imagePreview;
    }
    return;
  };
  render() {
    let list = this.props.projectList;
    return (
      <React.Fragment>
        <div className="projectMain">
          <div className="projecHeading">
            UNPUBLISHED {"(" + this.props.projCount + ")"}
          </div>
          <div className="projectBody">
            {list.map(item => {
              return (
                <div className="projectItem">
                  <div className="itemDate">published at {item.date}</div>
                  <div className="itemTitle">
                    <span>{item.subdomain}</span>{" "}
                    <span>
                      <Ionicon icon="ios-menu" fontSize={16} />
                    </span>
                  </div>
                  <div className="itemLogo perfectCenter">
                    <img src={Test} />
                    {/* <img src={item.logo} /> */}
                  </div>
                  <div className="absoluteItem perfectCenter">
                    <Ionicon icon="ios-paw" fontSize={26} />
                  </div>
                </div>
              );
            })}
            {/* <Link to="/project_register"> */}
            <div
              className="projectItem perfectCenter addProject"
              onClick={this.props.toggle}
            >
              <Ionicon icon="ios-add-circle" fontSize={46} color="gray" />
              <div className="itemTitle ">Create New Project</div>
            </div>
            {/* </Link> */}
          </div>
        </div>
      </React.Fragment>
    );
  }
}
